'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = function (value, params) {
  if (!['string', 'number'].includes(typeof value === 'undefined' ? 'undefined' : _typeof(value))) return true;
  if (value === '') return true;

  return isNaN(value);
};